import React from 'react';
import { Line } from 'react-chartjs-2';
import { Paper } from '@material-ui/core';

// Scan volume over the selected window, overlaid with the equal-length
// prior window (dashed) so the shape — not just the totals — is comparable.
const ScanTrend = ({ trend, trendPrior }) => {
  const hasData = trend && trend.length > 0;

  const data = {
    labels: hasData ? trend.map((p) => p.date.slice(5)) : [],
    datasets: [
      {
        label: 'This period',
        fill: false,
        borderColor: 'rgb(40, 196, 252)',
        pointBackgroundColor: 'rgb(20, 46, 62)',
        pointRadius: trend && trend.length > 45 ? 0 : 2,
        data: hasData ? trend.map((p) => p.scans) : [],
      },
      {
        label: 'Prior period',
        fill: false,
        borderColor: 'rgba(122, 138, 148, 0.7)',
        borderDash: [5, 4],
        pointRadius: 0,
        data: trendPrior ? trendPrior.map((p) => p.scans) : [],
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    legend: { display: true, position: 'bottom' },
    scales: {
      yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }],
      xAxes: [{ gridLines: { display: false } }],
    },
    tooltips: { mode: 'index', intersect: false },
    elements: { line: { tension: 0.25 } },
  };

  return (
    <Paper className="insights__card insights__col-8" variant="outlined">
      <div className="insights__card-head">
        <span className="insights__card-title">Scan Trend</span>
        <span className="insights__card-sub">current vs prior period</span>
      </div>
      {hasData ? (
        <div style={{ height: 280 }}>
          <Line data={data} options={options} />
        </div>
      ) : (
        <div className="insights__empty">No scans in this period.</div>
      )}
    </Paper>
  );
};

export default ScanTrend;
